import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { NotifyService } from 'src/app/modules/brover-notify/services/notify.service';
import { UserService } from 'src/app/modules/auth-client/services/user.service';
import { MatDialog as MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'brover-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.sass'],
    standalone: false
})
export class ProfileComponent implements OnInit {

  public user = { companies: [], orders: [], email: '', role: {rolename: ''} };
  public moment = moment;

  constructor(private notifyService: NotifyService, private userService: UserService, public dialog: MatDialog) { }

  ngOnInit() {
    this.updateDate();
  }

  public updateDate() {
    this.userService.getMe(true, true).subscribe(res => {
      this.user = res['data'];

      this.user['orders'].every(x => x.items = JSON.parse(x.items));
      this.user['orders'].forEach((order) => {
        let totalItems = 0;
        let totalPrice = 0;

        order.items.forEach((item) => {
          totalItems += item.qty;
          totalPrice += (item.qty * item.price);
        });

        order.totalItems = totalItems;

        if (!isNaN(totalPrice)) {
          order.totalPrice = '€ ' + totalPrice.toFixed(2);
        } else {
          order.totalPrice = '€ ' + 0;
        }


      });

      this.user['orders'].sort(function(a, b) {
        a = new Date(a.created);
        b = new Date(b.created);
        return a > b ? -1 : a < b ? 1 : 0;
      });
    });
  }

}
